export const META_DEFAULT_BASE_URL = 'https://www.udemy.com';

// Add custom global application constants below
// <<Stencil::Block(globalAppConstants)>>
// <</Stencil::Block>>
